import React from "react";
import '../../App.css'
import RequestInformationFormCard from "../RequestInformationFormCard";
export default function RequestInformationForm(){
    return (
        <>
            <RequestInformationFormCard />
        </>

    )
}